import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SingleFilterControl} from '../../../interface/single-filter-control';

@Component({
	selector: 'fb-single-filter-config',
	templateUrl: './single-filter-config.component.html',
	styleUrls: ['./single-filter-config.component.scss']
})
export class SingleFilterConfigComponent {
	@Input() public control: SingleFilterControl = {} as SingleFilterControl;
	@Output() public onControlChange: EventEmitter<null> = new EventEmitter<null>();

	public collapse: boolean = true;

	constructor() {
	}

	public toggleCollapse(): void {
		this.collapse = !this.collapse;
	}

	public onChange(evt: any): void {

		this.control.options = evt.target.checked

		this.onControlChange.emit(null);
	}


}
